export default __webpack_public_path__ + "static/media/realEstate.bc681e19.svg";